import React from "react";

function SoftwareCard({ software }) {
  return (
    <div className="card">
      {/* Ürün görseli */}
      <img
        src={software.imageUrl}
        className="card-img-top"
        alt={`${software.name} Görseli`}
      />
      <div className="card-body">
        <h5 className="card-title">{software.name}</h5>
        <p className="card-text">{software.description}</p>
        <a href={software.downloadUrl} className="btn btn-primary">
          İndir
        </a>
      </div>
    </div>
  );
}

export default SoftwareCard;
